import { render } from "./ObjectView.vue?vue&type=template&id=5086ba1d&scoped=true"
import script from "./ObjectView.vue?vue&type=script&lang=js"
export * from "./ObjectView.vue?vue&type=script&lang=js"

import "./ObjectView.vue?vue&type=style&index=0&id=5086ba1d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5086ba1d"

export default script